import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface EmployeesState {
  data: any;
  controllingOfficerData: any;
  updateAddressData: any;
  updateContactData: any;
  verifyContactData: any;
  profileReasonsData: any;
  policeVerificationData: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action:
    | "list"
    | "assign-office"
    | "my-profile"
    | "employee-profile"
    | "update-address"
    | "assign-role"
    | "update-contact"
    | "verify-contact"
    | "sync-from-sap"
    | "profile-reasons"
    | "update-verification-status"
    | "update-profile-reasons"
    | "employee-change-password"
    | "bulk-update-login-status"
    | "profile-picture-history"
    | "update-profile-picture"
    | "police-verification-status"
    | null;
}

const employeesInitialState: EmployeesState = {
  data: null,
  controllingOfficerData: null,
  updateAddressData: null,
  updateContactData: null,
  verifyContactData: null,
  profileReasonsData: null,
  policeVerificationData: null,
  loading: "idle",
  error: null,
  action: null,
};

export const syncFromSap: any = createAsyncThunk(
  "sync/employees",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.SYNC_FROM_SAP,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getPoliceVerificationStatus: any = createAsyncThunk(
  "get/police-verification-status",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.POLICE_VERIFICATION.STATUS, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const assignRole: any = createAsyncThunk(
  "assign/role",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.EMPLOYEES.ASSIGN_ROLE, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getEmployees: any = createAsyncThunk(
  "get/employees",
  async (payload: any, thunkAPI) => {
    try {
      const requestPayload = { ...payload };
      const response = await Api.post(API_URLS.EMPLOYEES.FIND_ALL, requestPayload);
      console.log("response", response.data);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
export const getMyProfile: any = createAsyncThunk(
  "get/my-profile",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.EMPLOYEES.My_PROFILE, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
export const getEmployeeProfile: any = createAsyncThunk(
  "get/employee-profile",
  async (payload: any, thunkAPI) => {
    try {
      const requestBody = {
        id: payload.empId,
      };
      const response = await Api.post(
        API_URLS.EMPLOYEES.EMPLOYEE_PROFILE,
        requestBody
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
export const updateEmergencyContact: any = createAsyncThunk(
  "get/employee-profile",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPDATE_EMERGENCY_CONTACT,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const updateEmployeeAddress: any = createAsyncThunk(
  "update/employeeAddress",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.ADD_UPDATE_ADDRESS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const updateEmployeeContact: any = createAsyncThunk(
  "update/employeeContact",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEE_AUTH.UPDATE_CONTACT,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const verifyEmployeeContact: any = createAsyncThunk(
  "verify/employeeContact",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEE_AUTH.VERIFY_CONTACT,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const assignOffice: any = createAsyncThunk(
  "assign/officeLocation",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.ASSIGN_OFFICE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getProfileReasons: any = createAsyncThunk(
  "get/profile-reasons",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.PROFILE_REASONS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const updateProfileReasons: any = createAsyncThunk(
  "update/profile-reasons",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPDATE_PROFILE_REASONS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const updateVerificationStatus: any = createAsyncThunk(
  "update/verification-status",
  async (payload: { id: number; status: string }, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPDATE_VERIFICATION_STATUS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const employeeChangePassword: any = createAsyncThunk(
  "employee/changePassword",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.EMPLOYEE_CHANGE_PASSWORD,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getProfilePictureHistory: any = createAsyncThunk(
  "employee/getProfilePictureHistory",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.PROFILE_PICTURE_HISTORY,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const updateProfilePicture: any = createAsyncThunk(
  "employee/updateProfilePicture",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPLOAD_PROFILE_PICTURE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const bulkUpdateLoginStatus: any = createAsyncThunk(
  "employees/bulkUpdateLoginStatus",
  async (payload: { empIds: string[]; login_on: boolean }, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPDATE_LOGIN_ON_OFF,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const employeesSlice = createSlice({
  name: "reset",
  initialState: employeesInitialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.data = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(employeeChangePassword.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "employee-change-password";
    });
    builder.addCase(employeeChangePassword.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "employee-change-password";
    });
    builder.addCase(employeeChangePassword.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "employee-change-password";
    });

    builder.addCase(assignRole.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "assign-role";
    });
    builder.addCase(assignRole.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "assign-role";
    });
    builder.addCase(assignRole.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "assign-role";
    });

    builder.addCase(getEmployees.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getEmployees.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getEmployees.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });

    builder.addCase(assignOffice.pending, (state) => {
      state.data = null;
      state.error = null;
      state.loading = "pending";
      state.action = "assign-office";
    });
    builder.addCase(assignOffice.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "fulfilled";
      state.action = "assign-office";
      state.error = null;
    });
    builder.addCase(assignOffice.rejected, (state, action) => {
      state.error = action.payload as string;
      state.data = null;
      state.loading = "rejected";
      state.action = "assign-office";
    });

    builder.addCase(getMyProfile.pending, (state) => {
      state.data = null;
      state.error = null;
      state.loading = "pending";
      state.action = "my-profile";
    });
    builder.addCase(getMyProfile.fulfilled, (state, action) => {
      // Show all family members without filtering by dependency type
      state.data = action.payload;
      state.loading = "fulfilled";
      state.action = "my-profile";
      state.error = null;
    });
    builder.addCase(getMyProfile.rejected, (state, action) => {
      state.error = action.payload as string;
      state.data = null;
      state.loading = "rejected";
      state.action = "my-profile";
    });

    builder.addCase(getEmployeeProfile.pending, (state) => {
      state.controllingOfficerData = null;
      state.error = null;
      state.loading = "pending";
      state.action = "employee-profile";
    });
    builder.addCase(getEmployeeProfile.fulfilled, (state, action) => {
      // Show all family members without filtering by dependency type
      state.controllingOfficerData = action.payload;
      state.loading = "fulfilled";
      state.action = "employee-profile";
      state.error = null;
    });
    builder.addCase(getEmployeeProfile.rejected, (state, action) => {
      state.error = action.payload as string;
      state.controllingOfficerData = null;
      state.loading = "rejected";
      state.action = "employee-profile";
    });

    builder.addCase(updateEmployeeAddress.pending, (state) => {
      state.updateAddressData = null;
      state.error = null;
      state.loading = "pending";
      state.action = "update-address";
    });
    builder.addCase(updateEmployeeAddress.fulfilled, (state, action) => {
      state.updateAddressData = action.payload;
      state.loading = "fulfilled";
      state.error = null;
      state.action = "update-address";
    });
    builder.addCase(updateEmployeeAddress.rejected, (state, action) => {
      state.error = action.payload as string;
      state.updateAddressData = null;
      state.loading = "rejected";
      state.action = "update-address";
    });

    builder.addCase(updateEmployeeContact.pending, (state) => {
      state.updateContactData = null;
      state.loading = "pending";
      state.error = null;
      state.action = "update-contact";
    });
    builder.addCase(updateEmployeeContact.fulfilled, (state, action) => {
      state.updateContactData = action.payload;
      state.loading = "fulfilled";
      state.error = null;
      state.action = "update-contact";
    });
    builder.addCase(updateEmployeeContact.rejected, (state, action) => {
      state.updateContactData = null;
      state.error = action.payload as string;
      state.loading = "rejected";
      state.action = "update-contact";
    });

    builder.addCase(verifyEmployeeContact.pending, (state) => {
      state.verifyContactData = null;
      state.loading = "pending";
      state.error = null;
      state.action = "verify-contact";
    });
    builder.addCase(verifyEmployeeContact.fulfilled, (state, action) => {
      state.verifyContactData = action.payload;
      state.loading = "fulfilled";
      state.error = null;
      state.action = "verify-contact";
    });
    builder.addCase(verifyEmployeeContact.rejected, (state, action) => {
      state.verifyContactData = null;
      state.error = action.payload as string;
      state.loading = "rejected";
      state.action = "verify-contact";
    });

    // sync from sap

    builder.addCase(syncFromSap.pending, (state) => {
      state.data = null;
      state.loading = "pending";
      state.error = null;
      state.action = "sync-from-sap";
    });
    builder.addCase(syncFromSap.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "fulfilled";
      state.error = null;
      state.action = "sync-from-sap";
    });
    builder.addCase(syncFromSap.rejected, (state, action) => {
      state.data = null;
      state.error = action.payload as string;
      state.loading = "rejected";
      state.action = "sync-from-sap";
    });

    builder.addCase(getProfileReasons.pending, (state) => {
      state.data = null;
      state.loading = "pending";
      state.error = null;
      state.action = "profile-reasons";
    });
    builder.addCase(getProfileReasons.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "fulfilled";
      state.error = null;
      state.action = "profile-reasons";
    });
    builder.addCase(getProfileReasons.rejected, (state, action) => {
      state.data = null;
      state.error = action.payload as string;
      state.loading = "rejected";
      state.action = "profile-reasons";
    });

    builder.addCase(updateProfileReasons.pending, (state) => {
      state.loading = "pending";
      state.error = null;
      state.action = "update-profile-reasons";
    });
    builder.addCase(updateProfileReasons.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.error = null;
      state.action = "update-profile-reasons";
    });
    builder.addCase(updateProfileReasons.rejected, (state, action) => {
      state.error = action.payload as string;
      state.loading = "rejected";
      state.action = "update-profile-reasons";
    });

    builder.addCase(updateVerificationStatus.pending, (state) => {
      state.loading = "pending";
      state.error = null;
      state.action = "update-verification-status";
    });
    builder.addCase(updateVerificationStatus.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.error = null;
      state.action = "update-verification-status";
    });
    builder.addCase(updateVerificationStatus.rejected, (state, action) => {
      state.error = action.payload as string;
      state.loading = "rejected";
      state.action = "update-verification-status";
    });

    builder.addCase(bulkUpdateLoginStatus.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "bulk-update-login-status";
    });
    builder.addCase(bulkUpdateLoginStatus.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "bulk-update-login-status";
    });
    builder.addCase(bulkUpdateLoginStatus.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "bulk-update-login-status";
    });

    builder.addCase(getProfilePictureHistory.pending, (state) => {
      state.loading = "pending";
      state.error = null;
      state.action = "profile-picture-history";
    });
    builder.addCase(getProfilePictureHistory.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.error = null;
      state.action = "profile-picture-history";
    });
    builder.addCase(getProfilePictureHistory.rejected, (state, action) => {
      state.error = action.payload as string;
      state.loading = "rejected";
      state.action = "profile-picture-history";
    });

    builder.addCase(updateProfilePicture.pending, (state) => {
      state.loading = "pending";
      state.error = null;
      state.action = "update-profile-picture";
    });
    builder.addCase(updateProfilePicture.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.error = null;
      state.action = "update-profile-picture";
    });
    builder.addCase(updateProfilePicture.rejected, (state, action) => {
      state.error = action.payload as string;
      state.loading = "rejected";
      state.action = "update-profile-picture";
    });
    builder.addCase(getPoliceVerificationStatus.pending, (state) => {
      state.loading = "pending";
      state.policeVerificationData = null;
      state.error = null;
      state.action = "police-verification-status";
    });
    builder.addCase(getPoliceVerificationStatus.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.policeVerificationData = action.payload;
      state.error = null;
      state.action = "police-verification-status";
    });
    builder.addCase(getPoliceVerificationStatus.rejected, (state, action) => {
      state.error = action.payload as string;
      state.loading = "rejected";
      state.policeVerificationData = null;
      state.action = "police-verification-status";
    });
  },
});

export const { resetAll } = employeesSlice.actions;
export default employeesSlice.reducer;
